var brandInfoAll = {
  bannerInfo: {
    bannerNmae: "汉瓦真空",
    createTime: "2000年",
    area: "中国 无锡",
    honor: ["EMS认证", "QMS认证"]
  },
  subsidiary: [
    {
      name: "无锡",
      langname: "无锡（工厂）",
      address: "江苏省无锡市锡山区尤沈路75号",
      corporateName: "汉瓦真空技术（无锡）有限公司"
    },
    {
      name: "无锡",
      langname: "无锡(研发中心)",
      address: "无锡市崇安区广南路313-2609",
      corporateName: "无锡瀚华自动化科技有限公司"
    },
    {
      name: "德国",
      langname: "德国(办事处)",
      address: "Hundhausen str 57， 41515， Grevenbroich，Germany",
      corporateName: "BAO GmbH"
    }
  ],
  advantages: {
    advantages: "/static/brand/zhitong/youshi/left.png",
    advantagesTitle: "/static/brand/zhitong/youshi/top.png",
    info:
      "产品在效率、空程、温升、噪音等指标上达到了国外主流产品水平。精度保持性、传动精度和刚性等3项指标略优，疲劳寿命指标大幅优于国外主流产品。",
    type: 1
  },
  certify: [],

  otherProductsAdvantages: {
    productsTitle: "/static/brand/zhitong/tedian/title.png",
    aboutTitleWidth: "849px",
    textList: [
      "高质量|进口海绵，进口原胶，进口材料，更高要求的优质材料",
      "高效定制|专业工程师设计，凭借多年经验数据，快速定制有效方案",
      "高技术|联合多个领域，突破多方面瓶颈，获取多项专利。",
      "高生产力|遵循统筹规划，使用先进的进口机床，专用设备，快速交付"
    ],
    textImg: "/static/brand/hanwa/product.png",
    height: "215px",
    list: [
      {
        titleImg: "/static/brand/hanwa/advantages/1.png",
        title:"真空吸盘",
        infoList: [
          "卓越的密封性能，减少能源消耗",
          "密封唇柔软，适应性强",
          "插入式连接，拆卸快速",
          "减少系统维护和停机时间"
        ]
      },
      {
        titleImg: "/static/brand/hanwa/advantages/2.png",
        title:"真空吸具",
        infoList: [
          "中型标准化设计",
          "简单便利的维修保养",
          "采用轻而坚韧的高强度铝型材",
          "内置多级真空发生器模块",
          "不同孔形技术适应更多的工件应用",
        ]
      },
      {
        titleImg: "/static/brand/hanwa/advantages/3.png",
        title:"真空发生器",
        infoList: [
          "坚固的铝合金本体，多种安装设计",
          "模块化快速便利安装设计",
          "节能高效，低噪音，高真空，大流量，易维护",
          "支持客户自由配置，满足特定系统的控制需求",
        ]
      }
    ]
  },
  pindustry: {
    industryTitleImg: "/static/brand/zhitong/hangye/industryTitleImg.png",
    list: [
      {
        bjimg: "/static/brand/hanwa/industry/1.png",
        title: "汽车"
      },
      {
        bjimg: "/static/brand/hanwa/industry/2.png",
        title: "木材"
      },
      {
        bjimg: "/static/brand/hanwa/industry/3.png",
        title: "医药"
      },
      {
        bjimg: "/static/brand/hanwa/industry/4.png",
        title: "包装"
      },
      {
        bjimg: "/static/brand/hanwa/industry/5.png",
        title: "机械制造"
      },
      {
        bjimg: "/static/brand/hanwa/industry/6.png",
        title: "物流"
      }
    ]
  },
  bigimg: "/static/brand/zhitong/bigimg/big.png",

  aboutus: {
    info:
      "HANWHA，成立于2000年，是一家集成机器人末端技术研发、生产、销售等技术服务为一体的多元化高科技企业。总部位于无锡锡山高新技术开发区，并拥有多个研发中心，分布在亚洲和欧洲。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;产品系列:真空吸具系统、真空取盘、真空发生器，等真空零部件，一直以完善的品质、优质的服务、合理的价格致力于客户，为了更好的提高公司的研发和制造能力，公司特从德国、日本、韩国、台湾等地大力引进更加先进的工艺设备。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们的产品广泛应用在木工行业、包装行业、电子行业、汽车行业、食品行业、建筑行业等领域。",
    poster: "/static/brand/hanwa/video.png",
    aboutTitle: "/static/brand/hanwa/top.png",
    aboutTitleWidth: "355px"
  },

  metaInfo: {
    title: "汉瓦真空_Movibot品牌_真空元件",
    keywords: "真空吸盘_真空吸具_真空发生器_汉瓦真空_ HANWHA",
    description:
      "汉瓦真空HANWHA是机器人末端技术研发、生产、销售等。产品包括真空吸具、真空吸盘、真空发生器。MOVIBOT为您提供该品牌及产品介绍，丰富的产品选型，让您更快速准确的找到所需商品。"
  }
};
export default {
  brandInfoAll
};



// WEBPACK FOOTER //
// ./src/data/brand/10.js